/**
 * Five Elements Quiz — Dynamic Height Handler
 * RevenueHunt Product Recommendation Quiz v2 Inline (App Block).
 * Handles height for both question pages (short) and results page (tall).
 * Height can grow AND shrink when transitioning between states.
 */
(function() {
  'use strict';

  // Only run on quiz pages — detect via section ID or app block presence
  var quizSection = document.querySelector('[id*="178480776170261c66"], .section-apps');
  if (!quizSection) return;

  var quizIframe = document.querySelector(
    'iframe[src*="revenuehunt"], iframe[src*="product-recommendation-quiz"], ' +
    'iframe[src*="quiz"], .app-block iframe'
  );

  // Track current height state — allows both increase and decrease
  var currentHeight = null;

  /**
   * Set iframe/wrapper height to an exact value.
   * Does NOT keep historical max — allows shrinking.
   */
  function setHeight(newHeight) {
    if (!newHeight || typeof newHeight !== 'number' || newHeight < 100 || newHeight > 12000) return;

    // Allow height to go up OR down
    currentHeight = newHeight;

    if (quizIframe) {
      quizIframe.style.height = newHeight + 'px';
      quizIframe.style.maxHeight = 'none';
      quizIframe.style.minHeight = 'auto';
    }

    // Also update wrapper containers — always set to auto, let iframe control
    var wrappers = document.querySelectorAll('.app-block, .app-block__container');
    wrappers.forEach(function(w) {
      w.style.height = 'auto';
      w.style.maxHeight = 'none';
      w.style.minHeight = 'auto';
      w.style.overflow = 'visible';
    });

    // Update quiz section if present
    if (quizSection) {
      quizSection.style.height = 'auto';
      quizSection.style.maxHeight = 'none';
      quizSection.style.minHeight = 'auto';
      quizSection.style.overflow = 'visible';
    }
  }

  /**
   * Reset height tracking — called when quiz state changes (question → result, restart, etc.)
   */
  function resetHeight() {
    currentHeight = null;
    // Temporarily set iframe to auto to let content determine size
    if (quizIframe) {
      quizIframe.style.height = 'auto';
      quizIframe.style.minHeight = 'auto';
    }
  }

  // ============================================================
  // A. Iframe mode: postMessage from RevenueHunt
  // ============================================================
  if (quizIframe) {
    window.addEventListener('message', function(event) {
      // RevenueHunt sends height updates via postMessage
      var data = event.data;
      if (!data || typeof data !== 'object') return;

      // Try known RevenueHunt message formats
      var height = data.height || data.quizHeight || data.iframeHeight ||
                   (data.payload && (data.payload.height || data.payload.quizHeight));

      if (height && typeof height === 'number' && height > 0) {
        // Validate reasonable height range
        if (height >= 50 && height <= 12000) {
          // Direct set — allows both growing and shrinking
          setHeight(height);
        }
      }

      // Handle RevenueHunt state messages: quiz loaded, question changed, result loaded, restarted
      if (data.type === 'quiz-loaded' || data.type === 'question-changed' ||
          data.type === 'result-loaded' || data.type === 'quiz-restarted' ||
          data.event === 'load' || data.event === 'question' ||
          data.event === 'result' || data.event === 'restart') {
        resetHeight();
      }
    });

    // On iframe load, remove any fixed height constraint
    quizIframe.addEventListener('load', function() {
      quizIframe.style.height = 'auto';
      quizIframe.style.minHeight = 'auto';
      quizIframe.style.maxHeight = 'none';
    });
  }

  // ============================================================
  // B. DOM-injected mode: ResizeObserver
  // ============================================================
  if (!quizIframe) {
    // Find the real quiz content container inside the app block
    var quizContainer = document.querySelector(
      '.quiz-container, .quiz-wrapper, [class*="rh-quiz"], [id*="quiz"], ' +
      '.app-block__container > div, .app-block > div'
    );

    if (quizContainer) {
      // Remove inner overflow
      quizContainer.style.overflow = 'visible';
      quizContainer.style.maxHeight = 'none';
      quizContainer.style.height = 'auto';
      quizContainer.style.minHeight = 'auto';

      var resizeObserver = new ResizeObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          var h = entries[i].contentRect.height;
          if (h > 0) {
            setHeight(h + 20); // small buffer
          }
        }
      });
      resizeObserver.observe(quizContainer);
    }

    // Fallback: observe the section for DOM changes
    var mutationObserver = new MutationObserver(function() {
      if (quizContainer) {
        quizContainer.style.height = 'auto';
        quizContainer.style.minHeight = 'auto';
        quizContainer.style.maxHeight = 'none';
      }
      // Reset wrappers
      var wrappers = document.querySelectorAll('.app-block, .app-block__container');
      wrappers.forEach(function(w) {
        w.style.height = 'auto';
        w.style.maxHeight = 'none';
        w.style.minHeight = 'auto';
        w.style.overflow = 'visible';
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ============================================================
  // C. Global cleanup — remove overflow and fixed height constraints
  // ============================================================
  function cleanupPage() {
    var containers = document.querySelectorAll('.app-block, .app-block__container');
    containers.forEach(function(c) {
      c.style.overflow = 'visible';
      c.style.overflowY = 'visible';
      c.style.maxHeight = 'none';
      c.style.minHeight = 'auto';
    });

    // Remove any iframe fixed height that's not ours
    if (quizIframe) {
      quizIframe.style.maxHeight = 'none';
      quizIframe.style.minHeight = 'auto';
    }
  }

  // Run on load
  cleanupPage();

  // Re-run on window resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      resetHeight();
      cleanupPage();
    }, 250);
  });

  // Also run after fonts load (can change text wrapping)
  if (document.fonts) {
    document.fonts.ready.then(function() {
      resetHeight();
      cleanupPage();
    });
  }
})();
